import { Alert, Button } from "@mui/material";
import { toast } from "react-hot-toast";

import type { FC } from "react";

export const UploadFileSuccessToast: FC<{ fileTitle: string; onClick: () => void }> = ({
  fileTitle,
  onClick,
}) => (
  <Alert
    severity="success"
    action={
      <Button
        onClick={() => {
          toast.remove();
          onClick();
        }}
        data-analytics-id="upload-file-success-toast"
        variant="text"
      >
        View File
      </Button>
    }
    sx={{ alignItems: "center", "& .MuiAlert-action": { pt: 0 } }}
  >
    {`"${fileTitle}" uploaded successfully`}
  </Alert>
);
